/** Временно СКРЫТЫЕ куски раздела распределения.
 *
 *  Код НЕ удалён: каждый флаг возвращает свой блок обратно правкой `false → true`, без единого
 *  восстановления логики. Так сделано осознанно — функции рабочие, просто рано.
 *
 *  Почему скрыто (сентябрь 2026): портал переводят на менеджеров по поставкам, и первым делом им
 *  нужен понятный минимум — «сколько везти в каждый регион».
 *  - `assembly` — доупаковка и весь пул флаконной модели ждут перехода на хранение по ОПТ. Пока
 *    его нет, «Доупак» показывает то, что физически собрать можно, но управленчески ещё нельзя.
 *  - `engine` — рекомендация движка делит дефицитный пул МЕЖДУ каналами по марже. Сейчас каждый
 *    менеджер ведёт свой маркетплейс, конкуренции за общий пул у них просто нет, а лишний слой
 *    «почему движок так решил» мешает освоить основное.
 *  - `topFilters` — поиск и фильтры каналов/регионов над таблицей: то же самое есть в колонках
 *    (по «Артикулу» и «Товару» — текстовый фильтр, он же ищет и по названию региона). Две панели
 *    фильтров рядом только путают («почему тут выбрал, а там не отфильтровалось»).
 *
 *  Порядок возврата и что именно скрывает каждый флаг — в `docs/supply-distribution.md`,
 *  § «Что временно скрыто в UI». */
export const SUPPLY_UI = {
  /** Флаконная модель: колонка «Доупак», остаток пула и красный дефицит, бейджи «вне флаконной
   *  модели» / «спека не разворачивается», баннер «остатки не сняты» и авто-снимок 1С.
   *
   *  НЕ прячет «Остаток ГП»: это физически лежащий на складе товар (живой `fetch_stock` по складу
   *  готовой продукции), менеджеру он нужен всегда — от флаконной модели зависит только «Доупак».
   *  Дата снимка 1С в «Снимках данных» тоже остаётся, но уже как справка о свежести данных: её
   *  прежний потребитель — бронь пула — выключен (`poolReserve`), а «Остаток ГП» читается живьём,
   *  не из снимка. */
  assembly: false,
  /** Рекомендация движка: панель стратегий, «Защита»/«Упаковка», иконки «почему?», «распределить
   *  выбранное». Без движка «Решение» предзаполняется расчётной потребностью «Допоставить». */
  engine: false,
  /** Вкладка «Производство» — план варок/котлов из той же флаконной модели: пока доупаковка
   *  скрыта, ей нечего показывать менеджеру по поставкам. Сама страница цела. */
  productionTab: false,
  /** Бронь пула флаконов целиком: вкладка «Брони», бейдж «без брони» и плашка про бронь в
   *  «Отгрузках». Выключена ВМЕСТЕ с механизмом на бэкенде (`POOL_RESERVE_ENABLED` в
   *  `backend/.../supply/features.py`) — прятать показ работающей брони было бы нечестно, её
   *  тогда нечем снять. Включать надо обе половины разом.
   *
   *  Бейдж и плашка скрыты и на СТАРЫХ фиксациях: их статус — правда о прошлом, но менеджеру,
   *  который про бронь ничего не знает, он говорит о несуществующей проблеме. */
  poolReserve: false,
  /** Раздел «Поставки Ozon» — цикл создания поставки из зафиксированного распределения.
   *
   *  Включён в проде с 14.09.2026 (решение владельца). Прежнее «перед слиянием поставить `false`»
   *  снято вместе со своей причиной: цикл доведён до конца — черновик → окно → заявка →
   *  грузоместа с кодами → заказ 1С, паллеты, ПТМО и счёт-фактура, — и прогнан боевыми поставками
   *  в двух кабинетах (коробочная, паллетная, микс и прямая; все отменены после проверки).
   *  Половина цикла и правда была бы хуже отсутствия, но половины больше нет.
   *
   *  ⚠️ Раздел пишет в ЖИВОЙ кабинет Ozon: заявка видна площадке, коды грузомест выдаются один
   *  раз, документы 1С проводятся. Необратимость каждого шага и порядок — в
   *  `docs/supply-ozon-supplies-plan.md`. */
  ozonSupplies: true,
  /** Вкладка «ФБС» — пополнение складов ФБС в 1С: расчёт потребности комнаты ФБС и заказ на
   *  перемещение со склада-источника. Спрос берётся из DWH по признаку `warehouse_type='fbs'`;
   *  пока Airflow его не заполнил, расчёт честно отвечает 503, а не пустой таблицей. */
  fbs: true,
  /** Дублирующие фильтры над таблицей: поиск «артикул / товар», «Все каналы», «Все регионы». */
  topFilters: false,
} as const;
